import { useCallback, useState } from 'react';

import {
  validateRows as validate,
  getInvalidItemsFromInvalidRows,
  getHighlightedRegions,
} from '../utils';

import type { Row } from '../types';

type HighlightRegions = ReturnType<typeof getHighlightedRegions>;

export type Validation = ReturnType<typeof validate>;

export const useTableValidation = () => {
  const [highlightRegions, setHighlightRegions] = useState<HighlightRegions>(
    []
  );

  const validateRows = useCallback((rows: Row[]) => {
    const validation = validate(rows);
    const { invalidRows } = validation;

    const invalidItems = getInvalidItemsFromInvalidRows(invalidRows);
    const highlightRegions = getHighlightedRegions(invalidItems);
    setHighlightRegions(highlightRegions);

    return validation;
  }, []);

  return {
    validateRows,
    highlightRegions,
  };
};
